import { API, handleApiError } from "./utils";
const path = "groups";

export const fetchGroups = async () => {
  try {
    const res = await API.get(`/${path}/fetch-groups`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createGroup = async (groupData) => {
  try {
    const res = await API.post(`/${path}/create-group`, groupData,{
      headers: {
        "Content-Type": "application/json",
      }
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const editGroup = async (organisationId, groupId, newRewardDistribution) => {
  try {
    const res = await API.post(`/${path}/edit-group`, {
      organisationId, groupId, newRewardDistribution
    },{
      headers: {
        "Content-Type": "application/json",
      }
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const renameGroup = async (organisationId, groupId, name) => {
  try {
    const res = await API.post(`/${path}/edit-group`, {
      organisationId, groupId, name
    },{
      headers: {
        "Content-Type": "application/json",
      }
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};


export const addMembers = async (organisationId, groupId, memberIds) => {
  try {
    const res = await API.post(`/${path}/add-members`, {
      organisationId, groupId, memberIds
    },{
      headers: {
        "Content-Type": "application/json",
      }
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteGroup = async (organisationId, groupId) => {
  try {
    const res = await API.post(`/${path}/delete-group`, {
      organisationId, groupId
    },{
      headers: {
        "Content-Type": "application/json",
      }
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const removeMembers = async (organisationId, groupId, memberIds) => {
  try {
    const res = await API.post(`/${path}/remove-members`, {
      organisationId, groupId, memberIds
    },{
      headers: {
        "Content-Type": "application/json",
      }
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};